import { useTranslation } from "next-i18next"

const CheckpriceErrorText = ({ errorCode }) => {

  const { t } = useTranslation('checkprice')

  let displayText = ''

  if (errorCode === 'ERR_DEFAULT') return null
  else if (errorCode === 'SERVICE_MAINTENANCE') displayText = 'Service maintenance'
  else if (errorCode.startsWith('ERR_MIN_ORDER_')) displayText = t('courier-errors.ERR_MIN_ORDER_X', { x: errorCode.match(/\d+/) })
  else if (errorCode.startsWith('ERR_SIZE_')) displayText = t('courier-errors.ERR_SIZE_X', { x: errorCode.match(/\d+/) })
  else displayText = t(`courier-errors.${errorCode}`)

  return (
    displayText
  )
}

export default CheckpriceErrorText